/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FreelancersListQuery
// ====================================================

export interface FreelancersListQuery_freelancersList_card {
    __typename: 'GdFreelancerCard';
    avatarUrl: string;
    briefInfo: string;
}

export interface FreelancersListQuery_freelancersList_mainSkill {
    __typename: 'GdFreelancerSkill';
    days: string;
    price: GraphQlBigDecimal;
    duration: GdFreelancerSkillOfferDuration;
}

export interface FreelancersListQuery_freelancersList_skills {
    __typename: 'GdFreelancerSkill';
    name: string;
}

export interface FreelancersListQuery_freelancersList_region_translation {
    __typename: 'GdFreelancerRegionTranslation';
    region: string;
    country: string;
}

export interface FreelancersListQuery_freelancersList_region {
    __typename: 'GdFreelancerRegion';
    translation: FreelancersListQuery_freelancersList_region_translation;
}

export interface FreelancersListQuery_freelancersList {
    __typename: 'GdFreelancerBase';
    freelancerId: GraphQlLong;
    login: string;
    card: FreelancersListQuery_freelancersList_card | null;
    fio: string;
    rating: number | null;
    mainSkill: FreelancersListQuery_freelancersList_mainSkill | null;
    skills: FreelancersListQuery_freelancersList_skills[];
    status: GdFreelancerStatus;
    workCurrency: CurrencyCode;
    feedbackCount: GraphQlLong | null;
    /**
     * Данные о стране и названии региона фрилансера.
     */
    region: FreelancersListQuery_freelancersList_region | null;
}

export interface FreelancersListQuery_operator {
    __typename: 'GdPublicOperatorInfo';
    clientId: GraphQlLong | null;
    login: string;
}

export interface FreelancersListQuery {
    freelancersList: (FreelancersListQuery_freelancersList | null)[];
    __typename: 'Query';
    operator: FreelancersListQuery_operator | null;
    /**
     * Получить reqId запроса
     */
    reqId: string;
}

export interface FreelancersListQueryVariables {
    lang: GdLanguageInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FreelancerPublicQuery
// ====================================================

export interface FreelancerPublicQuery_freelancersList_certificates {
    __typename: 'GdFreelancerCertificate';
    certId: GraphQlLong;
    type: GdFreelancerCertificateType;
    link: string;
}

export interface FreelancerPublicQuery_freelancersList_skills_priceMoney {
    __typename: 'GdMoney';
    valueAsFloat: number;
}

export interface FreelancerPublicQuery_freelancersList_skills {
    __typename: 'GdFreelancerSkill';
    name: string;
    skillId: GraphQlLong;
    duration: GdFreelancerSkillOfferDuration;
    priceMoney: FreelancerPublicQuery_freelancersList_skills_priceMoney;
}

export interface FreelancerPublicQuery_freelancersList_card_contacts {
    __typename: 'GdFreelancerContacts';
    siteUrl: string | null;
    whatsApp: string | null;
    phone: string;
    icq: string | null;
    telegram: string | null;
    email: string;
    viber: string | null;
    skype: string | null;
}

export interface FreelancerPublicQuery_freelancersList_card {
    __typename: 'GdFreelancerCard';
    briefInfo: string;
    avatarUrl: string;
    contacts: FreelancerPublicQuery_freelancersList_card_contacts;
}

export interface FreelancerPublicQuery_freelancersList_feedbacks_authorInfo {
    __typename: 'GdUserPublicInfo';
    avatarUrl: string;
    login: string;
    name: string;
    userId: GraphQlLong;
}

export interface FreelancerPublicQuery_freelancersList_feedbacks {
    __typename: 'GdFreelancerFeedback';
    authorInfo: FreelancerPublicQuery_freelancersList_feedbacks_authorInfo | null;
    authorUid: GraphQlLong;
    createdTime: GraphQlLocalDateTime;
    feedbackId: string;
    feedbackText: string;
    freelancerId: GraphQlLong;
    overallMark: GraphQlLong;
    willRecommend: boolean | null;
    moderationStatus: GdFreelancerUgcModerationStatus;
}

export interface FreelancerPublicQuery_freelancersList_mainSkill_priceMoney {
    __typename: 'GdMoney';
    valueAsFloat: number;
}

export interface FreelancerPublicQuery_freelancersList_mainSkill {
    __typename: 'GdFreelancerSkill';
    days: string;
    duration: GdFreelancerSkillOfferDuration;
    name: string;
    priceMoney: FreelancerPublicQuery_freelancersList_mainSkill_priceMoney;
}

export interface FreelancerPublicQuery_freelancersList_region_translation {
    __typename: 'GdFreelancerRegionTranslation';
    region: string;
    country: string;
}

export interface FreelancerPublicQuery_freelancersList_region {
    __typename: 'GdFreelancerRegion';
    translation: FreelancerPublicQuery_freelancersList_region_translation;
}

export interface FreelancerPublicQuery_freelancersList {
    __typename: 'GdFreelancerBase';
    freelancerId: GraphQlLong;
    fio: string;
    login: string;
    workCurrency: CurrencyCode;
    status: GdFreelancerStatus;
    rating: number | null;
    certificates: FreelancerPublicQuery_freelancersList_certificates[];
    skills: FreelancerPublicQuery_freelancersList_skills[];
    card: FreelancerPublicQuery_freelancersList_card | null;
    feedbacks: FreelancerPublicQuery_freelancersList_feedbacks[] | null;
    mainSkill: FreelancerPublicQuery_freelancersList_mainSkill | null;
    /**
     * Данные о стране и названии региона фрилансера.
     */
    region: FreelancerPublicQuery_freelancersList_region | null;
}

export interface FreelancerPublicQuery_operator {
    __typename: 'GdPublicOperatorInfo';
    clientId: GraphQlLong | null;
    login: string;
}

export interface FreelancerPublicQuery {
    /**
     * Получить reqId запроса
     */
    reqId: string;
    freelancersList: (FreelancerPublicQuery_freelancersList | null)[];
    __typename: 'Query';
    operator: FreelancerPublicQuery_operator | null;
}

export interface FreelancerPublicQueryVariables {
    freelancerLogin: string;
    lang: GdLanguageInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FreelancersListItemFragment
// ====================================================

export interface FreelancersListItemFragment_card {
    __typename: 'GdFreelancerCard';
    avatarUrl: string;
    briefInfo: string;
}

export interface FreelancersListItemFragment_mainSkill {
    __typename: 'GdFreelancerSkill';
    days: string;
    price: GraphQlBigDecimal;
    duration: GdFreelancerSkillOfferDuration;
}

export interface FreelancersListItemFragment_skills {
    __typename: 'GdFreelancerSkill';
    name: string;
}

export interface FreelancersListItemFragment_region_translation {
    __typename: 'GdFreelancerRegionTranslation';
    region: string;
    country: string;
}

export interface FreelancersListItemFragment_region {
    __typename: 'GdFreelancerRegion';
    translation: FreelancersListItemFragment_region_translation;
}

export interface FreelancersListItemFragment {
    __typename: 'GdFreelancerBase';
    freelancerId: GraphQlLong;
    login: string;
    card: FreelancersListItemFragment_card | null;
    fio: string;
    rating: number | null;
    mainSkill: FreelancersListItemFragment_mainSkill | null;
    skills: FreelancersListItemFragment_skills[];
    status: GdFreelancerStatus;
    workCurrency: CurrencyCode;
    feedbackCount: GraphQlLong | null;
    /**
     * Данные о стране и названии региона фрилансера.
     */
    region: FreelancersListItemFragment_region | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FreelancerFeedbackQueryFragment
// ====================================================

export interface FreelancerFeedbackQueryFragment_authorInfo {
    __typename: 'GdUserPublicInfo';
    avatarUrl: string;
    login: string;
    name: string;
    userId: GraphQlLong;
}

export interface FreelancerFeedbackQueryFragment {
    __typename: 'GdFreelancerFeedback';
    authorInfo: FreelancerFeedbackQueryFragment_authorInfo | null;
    authorUid: GraphQlLong;
    createdTime: GraphQlLocalDateTime;
    feedbackId: string;
    feedbackText: string;
    freelancerId: GraphQlLong;
    overallMark: GraphQlLong;
    willRecommend: boolean | null;
    moderationStatus: GdFreelancerUgcModerationStatus;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FreelancerContactsFragment
// ====================================================

export interface FreelancerContactsFragment {
    __typename: 'GdFreelancerContacts';
    siteUrl: string | null;
    whatsApp: string | null;
    phone: string;
    icq: string | null;
    telegram: string | null;
    email: string;
    viber: string | null;
    skype: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FreelancerPublicOperatorFragment
// ====================================================

export interface FreelancerPublicOperatorFragment_operator {
    __typename: 'GdPublicOperatorInfo';
    clientId: GraphQlLong | null;
    login: string;
}

export interface FreelancerPublicOperatorFragment {
    __typename: 'Query';
    operator: FreelancerPublicOperatorFragment_operator | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum CurrencyCode {
    BYN = 'BYN',
    CHF = 'CHF',
    EUR = 'EUR',
    KZT = 'KZT',
    RUB = 'RUB',
    TRY = 'TRY',
    UAH = 'UAH',
    USD = 'USD',
    UZS = 'UZS',
    YND_FIXED = 'YND_FIXED'
}

export enum GdFreelancerCertificateType {
    DIRECT = 'DIRECT',
    DIRECT_PRO = 'DIRECT_PRO',
    METRIKA = 'METRIKA'
}

export enum GdFreelancerSkillOfferDuration {
    FROM_14_TO_28_DAYS = 'FROM_14_TO_28_DAYS',
    FROM_1_TO_3_DAYS = 'FROM_1_TO_3_DAYS',
    FROM_1_TO_3_MONTHS = 'FROM_1_TO_3_MONTHS',
    FROM_3_TO_7_DAYS = 'FROM_3_TO_7_DAYS',
    FROM_7_TO_14_DAYS = 'FROM_7_TO_14_DAYS',
    MONTHLY = 'MONTHLY',
    MORE_THAN_3_MONTHS = 'MORE_THAN_3_MONTHS',
    NOT_DEFINED = 'NOT_DEFINED'
}

export enum GdFreelancerStatus {
    BUSY = 'BUSY',
    FREE = 'FREE'
}

export enum GdFreelancerUgcModerationStatus {
    ACCEPTED = 'ACCEPTED',
    DECLINED = 'DECLINED',
    IN_PROGRESS = 'IN_PROGRESS'
}

export enum GdLanguageInput {
    EN = 'EN',
    RU = 'RU',
    TR = 'TR',
    UK = 'UK'
}

//==============================================================
// END Enums and Input Objects
//==============================================================
